<template>
  <w-icon-wrapper
    icon-name="work-move-project-icon"
    :height="24"
    :width="24"
    view-box="0 0 24 24"
  >
    <g
      id="_83_Buchung_verschieben"
      data-name="83 Buchung verschieben"
      transform="translate(0.042 -0.108)"
    >
      <path
        id="Pfad_55826"
        data-name="Pfad 55826"
        d="M16.222,22.108H1.991v-20h8.132v6h6.1v2h2.033v-4l-6.1-6H-.042v24h18.3v-4H16.222ZM12.156,2.938l3.222,3.17H12.156Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55827"
        data-name="Pfad 55827"
        d="M23.255,14.448a.961.961,0,0,0-.079-.077L20.185,11.4a1.029,1.029,0,0,0-1.438-.006.988.988,0,0,0-.006,1.414l1.307,1.3H9.3a1,1,0,1,0,0,2H20.032l-1.341,1.283a.988.988,0,0,0-.02,1.414,1.029,1.029,0,0,0,1.437.021l3.85-3.681Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconMoveProject' };
</script>
